<template>
    <div>
        <button class="primary" @click="resetCache">Reset Cache</button>
    </div>
</template>
<script setup>

import toastStore from '@/store/toast.store.js';

const resetCache = () => {
    fetch('/api/admin/cache/reset', {
        method: 'GET',
    }).then(response => response.json()).then(() => {
        toastStore.dispatch('addMessage', {
            title: 'Cache Reset',
            message: 'Cache reset successfully',
            icon: 'success'
        });
    }).catch(error => {
        console.log(error)
        toastStore.dispatch('addMessage', {
            title: 'Cache Reset',
            message: 'Cache reset failed',
            icon: 'error'
        });
    });
}


</script>